import { render } from "./sideMenu.vue?vue&type=template&id=19696a41&ts=true"
import script from "./sideMenu.vue?vue&type=script&lang=ts"
export * from "./sideMenu.vue?vue&type=script&lang=ts"

import "./sideMenu.vue?vue&type=style&index=0&id=19696a41&lang=scss"

import exportComponent from "/home/ssh/jigoucode/jigou_fe_v5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__